<div *ngIf="isVisible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">

        <div>

          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="sm:flex sm:items-start px-4 py-4 lg:px-6 lg:py-4">
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Collecting Data</h3>
              <div class="mt-2">

                <p class="text-sm text-gray-500 mb-3">
                  We're currently collecting data for report {{ searchId }}.
                </p>

                <ul role="list" class="divide-y divide-gray-100">
                  <li *ngFor="let data of dataList$ | async" class="flex justify-between gap-x-6 py-5">
                    <div class="flex items-center min-w-0 gap-x-4">
                      <div>
                        <app-pulse-loading [status]="data.status"></app-pulse-loading>
                      </div>
                      <div class="min-w-0 flex-auto">
                        <p class="text-sm/6 text-gray-900">{{ data.name }}</p>
                      </div>
                    </div>
                  </li>
                </ul>

              </div>
            </div>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button type="button" [disabled]="loading$ | async" (click)="closeModal()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Close</button>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
